import { MODERATED_ENTITY_TYPE_TO_LABEL, type ModeratedEntityType } from '../moderation'
import type { SerializedRichText } from '../richText/types'
import { faq } from '../url'

function getBodyForHiddenEntity(entity: ModeratedEntityType, type: 'rich-text'): SerializedRichText
function getBodyForHiddenEntity(entity: ModeratedEntityType, type: 'plain-text'): string
function getBodyForHiddenEntity(
  entity: ModeratedEntityType,
  type: 'rich-text' | 'plain-text'
): SerializedRichText | string {
  const communityGuidelinesLabel = 'community guidelines'
  const plainText = `This ${MODERATED_ENTITY_TYPE_TO_LABEL[entity]} has been hidden due to concerns that it violates our ${communityGuidelinesLabel}.`
  const splitPlainText = plainText.split(communityGuidelinesLabel)

  return type === 'plain-text'
    ? plainText
    : {
        content: [
          {
            type: 'paragraph',
            children: [
              {
                text: splitPlainText[0],
                italic: true,
              },
              {
                type: 'link',
                url: faq.getArticleUrl('community-guidelines'),
                children: [{ text: communityGuidelinesLabel, italic: true }],
              },
              {
                text: splitPlainText[1],
              },
            ],
          },
        ],
        serialization_method: 'slate_json_v1',
      }
}

export default getBodyForHiddenEntity
